/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Message } from 'primeng/api';

@Component({
  selector: 'm-messages',
  templateUrl: './m-messages.component.html',
  styleUrls: ['./m-messages.component.scss']
})
export class MMessagesComponent {
  @Input() messages: Message[] = [];
  @Input() fullScreen = false;
  @Input() closable = true;
  @Input() escape = true;
  @Input() variant: 'default' | 'small' = 'default';
  @Input() styleClass = '';

  @Output() closeMessage: EventEmitter<any> = new EventEmitter<any>();

  get materialIconStyle() {
    const firstMessage = this.messages[0];
    if (firstMessage?.icon && !firstMessage.icon.startsWith('pi-')) {
      return { '--material-icon': `"${firstMessage.icon}"` };
    }
    return {};
  }

  handleClose(event: any) {
    this.closeMessage.emit(event);
  }
}
